var $28feffc3d61a8691$exports = {};
$28feffc3d61a8691$exports = {
    "close": `Zav\u{159}\xedt`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ozn\xe1men\xed`,
            other: ()=>`${formatter.number(args.count)} ozn\xe1men\xed`
        })}.`
};


export {$28feffc3d61a8691$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
